import {setMode} from '@stencil/core';

setMode(() => {
  // <html data-density="low">
  // <my-component data-density="low"/>
  return (
    // (ele as any)['data-density'] ||
    // ele.getAttribute('data-density') ||
    document.documentElement.getAttribute('data-density') || 'medium'
  );
});
